import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Stack from "@mui/material/Stack";
import AreYouSure from "./AreYouSure";
import Button from "@mui/material/Button";
import DeleteOutlinedIcon from "@mui/icons-material/Delete";
import RotateRightIcon from "@mui/icons-material/RotateRight";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";

export default function InteriorPopoverClosure(interior) {
  let interval = {};

  const hold = (cb) => {
    interval = setInterval(() => {
      cb();
    }, 100);
  };

  const rotateRight = () => {
    interior.rotateOnAxis(
      new THREE.Vector3(0, 1, 0),
      (-Math.PI / 180) * APP.settings.objektRotationAngle
    );
    APP.dirty();
  };

  const rotateLeft = () => {
    interior.rotateOnAxis(
      new THREE.Vector3(0, 1, 0),
      (Math.PI / 180) * APP.settings.objektRotationAngle
    );
    APP.dirty();
  };

  const stopRotate = () => {
    clearInterval(interval);
  };

  const deleteInterior = () => {
    interior.booth.removeInterior(interior);
    APP.arrangement.popover = undefined;
    APP.dirty();
    // const onSuccess = () => {
    //   interior.booth.removeInterior(interior);
    //   APP.arrangement.popover = undefined;
    //   APP.arrangement.dialog = undefined;
    //   APP.dirty();
    // };
    // const onDecline = () => {
    //   APP.arrangement.dialog = undefined;
    //   APP.dirty();
    // };
    // APP.arrangement.setDialog({
    //   content: AreYouSure({
    //     onSuccess: onSuccess,
    //     onDecline: onDecline,
    //   }),
    // });
  };

  return function InteriorPopover() {
    return (
      <Box sx={{ margin: "1em" }}>
        <Stack spacing={1} direction="row">
          <Button
            onClick={() => {
              rotateRight();
            }}
            onMouseDown={() => hold(rotateRight)}
            onMouseUp={() => stopRotate()}
            sx={{ width: "50px" }}
            variant="contained"
          >
            <RotateRightIcon />
          </Button>
          <Button
            onClick={() => {
              rotateLeft();
            }}
            onMouseDown={() => hold(rotateLeft)}
            onMouseUp={() => stopRotate()}
            sx={{ width: "50px" }}
            variant="contained"
          >
            <RotateLeftIcon />
          </Button>
        </Stack>
        <Button
          className="removeInterior"
          onClick={deleteInterior}
          sx={{ width: "100%", marginTop: "5px" }}
          variant="contained"
          endIcon={<DeleteOutlinedIcon />}
        >
          <Typography variant="h6">{I18N("remove")}</Typography>
        </Button>
      </Box>
    );
  };
}
